<template>
    <div v-if="theModel">
      <div v-for="(opts, oi) in theModel/*.sort((a, b) => (b.Descriptor == 1 ? -1 : b.Descriptor) - (a.Descriptor == 1 ? -1 : a.Descriptor))*/" class="q-mb-xs" :key="oi">
        <div v-if="opts.Descriptor === 0" class="row" style="display: inline !important;">
          {{ $t('show_filtered_positions_only') }}&nbsp;
          <div style="display: inline !important;">
            <q-option-group
              style="max-width: fit-content; display: inline !important;"
              :options="[ { value: true, label: $t('yes') }, { value: false, label: $t('no')} ]"
              type="radio"
              size="20px"
              inline
              v-model="opts.Toggled"
            />
          </div>
        </div>
        <div v-if="opts.Descriptor === 2" class="row" style="display: inline !important;">
          {{ $t('show_original_selection_only') }}&nbsp;
          <div style="display: inline !important;">
            <q-option-group
              style="max-width: fit-content; display: inline !important;"
              :options="[ { value: true, label: $t('yes') }, { value: false, label: $t('no')} ]"
              type="radio"
              size="20px"
              inline
              v-model="opts.Toggled"
            />
          </div>
        </div>
        <div v-if="opts.Descriptor === 1">
          {{ $t('what_to_show_sum_qty_columns') }}:&nbsp;
          <q-option-group
            style="max-width: fit-content; display: inline !important;"
            :options="[ { value: 0, label: $t('separate_per_position_default')+';' }, 
              { value: 1, label: $t('sum_qty_shown_table')+';'}, 
              { value: 2, label: $t('sum_qty_all_action')+';'}
            ]"
            type="radio"
            size="20px"
            v-model="opts.DisplayKind"
          />
        </div>
      </div>
    </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import { settingsStore } from '@/store/settings';
import { AnalyticsElementOptionsDto } from '../../../models/interfaces/entity-settings/filters/filters';

@Component({
  name: 'ElementOptionsSettingsPanel'
})
export default class ElementOptionsSettingsPanel extends Vue {
  // v-model
  @Prop({ default: {} as AnalyticsElementOptionsDto[] })
  modelValue: AnalyticsElementOptionsDto[] | undefined
  @Emit("update:modelValue") emitModelValue(arg: any) { return arg; }

  setstore: any | undefined = undefined

  created() {
    this.setstore = settingsStore()
  }

  get theModel() {
    return this.modelValue
  }

  set theModel(arg: any) {
    this.emitModelValue(arg)
  }
}
</script>

<style lang="scss">
</style>